import type { ProviderCredit } from "@/features/admin";
import type { Tone } from "@/features/utils/colors";

/** Formatting shared by the credits page and its per-provider cards. */

export const money = (credit: ProviderCredit): string => {
  if (credit.balance === null) return "—";
  const value = credit.balance.toLocaleString("fr-FR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  return credit.currency === "USD"
    ? `${value} $`
    : `${value} ${credit.currency}`;
};

/** Where the figure comes from — shown next to it, because it changes how much to trust it. */
export const SOURCE_LABEL: Record<ProviderCredit["source"], string> = {
  api: "lu chez le fournisseur",
  derived: "crédit acheté − consommation",
  manual: "saisie manuelle",
  none: "aucune source",
};

export const STATUS_LABEL: Record<ProviderCredit["status"], string> = {
  ok: "OK",
  low: "Crédit bas",
  unknown: "Inconnu",
  error: "Erreur",
};

export const creditStatusTone = (
  status: ProviderCredit["status"],
): "default" | "warn" | "bad" =>
  status === "low" ? "bad" : status === "ok" ? "default" : "warn";

/** The status badge's tone: an unknown balance is a warning, never "empty". */
export const badgeTone = (status: ProviderCredit["status"]): Tone =>
  status === "low" ? "red" : status === "ok" ? "green" : "yellow";

export const when = (t: number): string =>
  t
    ? new Date(t).toLocaleString("fr-FR", {
        day: "2-digit",
        month: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
      })
    : "jamais";
